import { DELIVERY_OPTIONS_LIST, DELIVERY_AGENTS_LIST, MULTIPLE_ORDERS_LIST, ASSIGN_DELIVERY_BOY, SET_REASSIGN_FLAG, SET_SINGLE_ITEM_DETAILS } from '../actions/types';

const initialState = {
    deliveryOptionsList : [],
    deliveryAgentsList: [],
    multipleOrdersList: [],
    orderId: null,
    logistics_orderid: null,
    vendor_group_orderid: null,
    reassign_flag: false,
    paid_status: null,
    item_order_ids: []
}

export default (state = {...initialState}, { type , payload }) => {
    switch(type) {
        case DELIVERY_OPTIONS_LIST: {
            let newState = {...state};
            newState.deliveryOptionsList = payload.data || [];
            return {
                ...newState
            }
        }
        case DELIVERY_AGENTS_LIST: {
            let newState = {...state};
            newState.deliveryAgentsList = payload.data || [];
            return {
                ...newState
            }
        }
        case MULTIPLE_ORDERS_LIST: {
            let newState = {...state};
            newState.multipleOrdersList = payload.data && payload.data ? Object.values(payload.data) : [];
            return {
                ...newState
            }
        }
        case ASSIGN_DELIVERY_BOY: {
            let newState = {...state};
            return {
                ...newState
            }
        }
        case SET_REASSIGN_FLAG : {
            let newState = {...state};
            newState.reassign_flag = payload.flag
            return {
                ...newState
            }
        }
        case SET_SINGLE_ITEM_DETAILS: {
            let newState = {...state};
            newState.orderId = payload.orderId;
            newState.logistics_orderid = payload.logistics_orderid;
            newState.vendor_group_orderid= payload.vendor_group_orderid;
            newState.paid_status = payload.paid_status;
            newState.item_order_ids = payload.item_order_ids;
            return {
                ...newState
            }
        }
        default: {
            return {...state};
        }
    }
}